class SiteHeader {
  constructor(
    selector = ".site-header",
    {
      offset = 10,
      activeClass = "is-scrolled",
      desktopSelector = ".new-site-header",
      mobileNavSelector = ".mobile-nav",
      drawerCartSelector = "#shopify-section-slide-cart",
      headerDesktopSelector = "#shopify-section-header-desktop",
      mediaQuery = "(max-width: 990px)",
    } = {}
  ) {
    this.offset = offset;
    this.activeClass = activeClass;
    this.desktopSelector = desktopSelector;

    this.baseHeader =
      typeof selector === "string"
        ? document.querySelector(selector)
        : selector;
    this.mobileNav = document.querySelector(mobileNavSelector);
    this.drawerCart = document.querySelector(drawerCartSelector);
    this.desktopHeaderSection = document.querySelector(headerDesktopSelector);

    this.mql = window.matchMedia(mediaQuery);
    this.isMobile = this.mql.matches;

    this.header = this.resolveHeader();

    this.onScroll = this.rafThrottle(this.apply.bind(this));
    this.onMediaChange = this.onMediaChange.bind(this);

    if (!this.baseHeader) return;
    this.init();
  }

  init() {
    window.addEventListener("scroll", this.onScroll, { passive: true });
    if (this.mql.addEventListener) {
      this.mql.addEventListener("change", this.onMediaChange);
    } else {
      this.mql.addListener(this.onMediaChange);
    }
    this.apply();
  }

  destroy() {
    window.removeEventListener("scroll", this.onScroll);
    if (this.mql.removeEventListener) {
      this.mql.removeEventListener("change", this.onMediaChange);
    } else {
      this.mql.removeListener(this.onMediaChange);
    }
  }

  onMediaChange(e) {
    this.isMobile = e.matches;
    this.header = this.resolveHeader();
    this.apply();
  }

  resolveHeader() {
    if (!this.isMobile) {
      const desktop = document.querySelector(this.desktopSelector);
      if (desktop) return desktop;
    }
    return this.baseHeader;
  }

  apply() {
    const scrolled = (window.scrollY || window.pageYOffset || 0) > this.offset;
    this.baseHeader.classList.toggle(this.activeClass, scrolled);

    if (!this.mobileNav && !this.drawerCart && !this.desktopHeaderSection)
      return;

    const mobileTopNav = this.header?.querySelector(".mobile-top-nav");
    const baseHeight = this.baseHeader.getBoundingClientRect().height;
    const topNavHeight =
      scrolled && mobileTopNav
        ? mobileTopNav.getBoundingClientRect().height
        : baseHeight;

    const px = `${Math.round(topNavHeight)}px`;

    if (this.mobileNav)
      this.mobileNav.style.setProperty("--margin-mobile-top", px);
    if (this.drawerCart)
      this.drawerCart.style.setProperty("--margin-mobile-top", px);
    if (this.desktopHeaderSection)
      this.desktopHeaderSection.style.setProperty("--margin-mobile-top", px);
  }

  rafThrottle(fn) {
    let ticking = false;
    return (...args) => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        fn.apply(this, args);
        ticking = false;
      });
    };
  }
}

document.addEventListener("DOMContentLoaded", () => {
  new SiteHeader(".site-header", {
    offset: 50,
    activeClass: "is-scrolled",
    desktopSelector: ".new-site-header",
    mediaQuery: "(max-width: 990px)",
  });
});

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll("sub-menu-button").forEach((button) => {
    button.addEventListener("click", () => {
      const targetId = button.getAttribute("sub-menu");
      const container = document.querySelector(`sub-menu-container[sub-menu="${targetId}"]`);
      if (container) {
        container.classList.add("open");
      }
    });
  });

  document.querySelectorAll("sub-menu-close-button").forEach((closeBtn) => {
    closeBtn.addEventListener("click", () => {
      const targetId = closeBtn.getAttribute("sub-menu");
      const container = document.querySelector(`sub-menu-container[sub-menu="${targetId}"]`);
      if (container) {
        container.classList.remove("open");
      }
    });
  });
});
